import React from 'react';
import Axios from 'axios';
import moment from 'moment';
import AutoSuggestPlayer from '../../shared/AutoSuggest/AutoSuggestPlayer';

const autoSuggTheme = {
	container: 'react-autosuggest-std__container',
	input: 'react-autosuggest-std__input',
	inputOpen: 'react-autosuggest-std__input--open',
	inputFocused: 'react-autosuggest-std__input--focused',
	suggestionsContainer: 'react-autosuggest-std__suggestions-container',
	suggestionsContainerOpen: 'react-autosuggest-std__suggestions-container--open',
	suggestionsList: 'react-autosuggest-std__suggestions-list',
	suggestion: 'react-autosuggest-std__suggestion',
	suggestionHighlighted: 'react-autosuggest-std__suggestion--highlighted',
};

class EditUser extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			auth0_user_id: '',
			auth0_name: '',
			name: '',
			adminLevel: '',
			organisationsId: [],
			charters: [],
			leagues: [],
			seasons: [],
			playerId: null,
			memberActive: '',
			memberDateActivation: '',
			memberDateExpiration: '',
			picture: '',
 			streetaddress: '',
  		addresslevel2: '',
  		addresslevel1: '',
  		postalcode: '',
  		country: '',
  		email: '',
  		tel: '',
		};
	}

 	componentDidMount() {
		this.loadUserFromApi();
 	}

  loadUserFromApi = async () => {
    try {
      const res = await Axios.get(`/api/users/byUserId/${this.props.userEditId}/extended`);
      const user = res.data;

      this.setState({
        ...user,
        memberDateActivation: user.memberDateActivation
          ? moment(user.memberDateActivation).utc().format('YYYY-MM-DD')
          : '',
        memberDateExpiration: user.memberDateExpiration
          ? moment(user.memberDateExpiration).utc().format('YYYY-MM-DD')
          : '',
      });
    } catch (err) {
      console.error('Erreur loadUserFromApi:', err);
    }
  };

	handleSubmit = (e) => {
		e.preventDefault();
		var userData = {
			name: this.state.name,
			adminLevel: this.state.adminLevel,
			organisationsId: this.state.organisationsId,
			charters: this.state.charters,
			leagues: this.state.leagues,
			seasons: this.state.seasons,
			playerId: this.state.playerId?.toString() === '-1' ? null : this.state.playerId,
			memberActive: this.state.memberActive,
			memberDateActivation: this.state.memberDateActivation,
			memberDateExpiration: this.state.memberDateExpiration,
  		streetaddress: this.state.streetaddress,
  		addresslevel2: this.state.addresslevel2,
  		addresslevel1: this.state.addresslevel1,
  		postalcode: this.state.postalcode, 
  		country: this.state.country,
  		email: this.state.email,
  		tel: this.state.tel, 		
  	}

		var userId = this.props.userEditId;

		Axios.post('/api/users/edit', {
			userId: userId,
			userData: userData
		})
		.then(response => {
			this.props.onSubmitCancel();
		})
		.catch(error => {
			console.log(error);
		});
	}

	render() {
		//console.log('editUser: render')
    var defaultDate = new Date();
    defaultDate = moment(defaultDate.toISOString()).utc().format("YYYY-MM-DD");

    const { userEditId } = this.props;
    const { auth0_user_id, auth0_name, picture } = this.state;

		return (
			<div className="row">
        <div className="col-md-12">
        <form className="form-horizontal" onSubmit={this.handleSubmit}>

				<h4>Édition d'un utilisateur</h4>

				<div className="form-group">
        <div className="row">
        <div className="col-md-12">
        	{picture && (	<img className="img-profile-token" src={picture} alt='photo'/> )}
        	<br/><br/>
					id: {userEditId} <br/>
					auth0: {auth0_name} (user_id: {auth0_user_id}) <br/>
				</div>
				</div>
				</div>

				<div className="form-group">
        <div className="row">
        <div className="col-md-4">
					Nom Usager
					<input type="text" className="form-control" id="name" placeholder="Nom utilisateur"
						value={this.state.name || ''} onChange={this.handleChange}/>
				</div>
				</div>
				</div>

				<div className="form-group">
        <div className="row">
        <div className="col-md-4">
					Adresse
					<input type="text" className="form-control" id="streetaddress"
						value={this.state.streetaddress} onChange={this.handleChange}/>
				</div>
        <div className="col-md-4">
					Ville
					<input type="text" className="form-control" id="addresslevel2"
						value={this.state.addresslevel2} onChange={this.handleChange}/>
				</div>
        <div className="col-md-2">
					Province
					<input type="text" className="form-control" id="addresslevel1"
						value={this.state.addresslevel1} onChange={this.handleChange}/>
				</div>
        <div className="col-md-2">
					Code postal
					<input type="text" className="form-control" id="postalcode"
						value={this.state.postalcode} onChange={this.handleChange}/>
				</div>
				</div>
				</div>

				<div className="form-group">
        <div className="row">
        <div className="col-md-4">
					Pays
					<input type="text" className="form-control" id="country"
						value={this.state.country} onChange={this.handleChange}/>
				</div>
        <div className="col-md-4">
					Courriel
					<input type="text" className="form-control" id="email"
						value={this.state.email} onChange={this.handleChange}/>
				</div>
        <div className="col-md-4">
					Téléphone
					<input type="text" className="form-control" id="tel"
						value={this.state.tel} onChange={this.handleChange}/>
				</div>
				</div>
				</div>

				<div className="form-group">
        <div className="row">
        <div className="col-md-6">
					<input type="checkbox" id="memberActive" checked={this.state.memberActive} value="memberActive" 
						onChange={this.handleMemberActiveChange}/> Active member
				</div>
				</div>
				</div>

				<div className="form-group">
        <div className="row">
        <div className="col-md-4">
					Joueur
					<AutoSuggestPlayer theme={autoSuggTheme} playerId={this.state.playerId} dataChange={this.handlePlayerChange} />
				</div>
        <div className="col-md-4">
					Date d'activation (membre)
					<input className="form-control" type="date" id="memberDateActivation" 
            value={this.state.memberDateActivation || ''} 
						onChange={this.handleChange}></input>
				</div>
        <div className="col-md-4">
					Date d'expiration (membre)
					<input className="form-control" type="date" id="memberDateExpiration" 
						value={this.state.memberDateExpiration || ''} 
						onChange={this.handleChange}></input>
				</div>
				</div>
				</div>

				<div className="form-group">
        <div className="row">
        <div className="col-md-2">
					Niveau Admin
					<input type="number" className="form-control" id="adminLevel"
						value={this.state.adminLevel} onChange={this.handleAdminLevelChange}/>
				</div>
				</div>
				</div>

				<div className="form-group">
	      <div className="row">
	      <div className="col-md-12">
					Saisons
        	<table className="table table-striped table-hover table-sm">
        	<tbody>
         		<tr>
          		<th>ID</th>
            	<th>Name</th>
        		</tr>
        		{this.state.seasons.map(this.createSeasonRow)}
					</tbody>
        	</table>
				</div>
				</div>
				</div>

				<div className="form-group">
        <div className="row">
        <div className="col-md-12">
					<button type="submit" className="btn btn-primary">Sauvegarder</button>&nbsp;&nbsp;&nbsp;&nbsp;
					<button type="button" className="btn btn-primary"
						onClick={this.handleCancel}>Annuler</button>
				</div>
				</div>
				</div>

				</form>
			</div>
			</div>
		);
	}

	handleChange = (e) => this.setState({ [e.target.id]: e.target.value });
  handleAdminLevelChange = (e) => this.setState({ adminLevel: parseInt(e.target.value, 10) || 0 });
  handleMemberActiveChange = () => this.setState((prev) => ({ memberActive: !prev.memberActive }));
  handlePlayerChange = (playerId) => this.setState({ playerId });
  handleCancel = () => this.props.onSubmitCancel();

  createSeasonRow(season, seasonIdx) {
    return (
      <tr key={season.id}>
        <td>{season.id}</td>
        <td>{season.name}</td>
      </tr>
    );
  }

}

export default EditUser;